import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  inputs: {
    display: 'flex',
    rowGap: '1rem',
    columnGap: '1.25rem',
    width: '100%',
    p: '1rem',
    flexWrap: 'wrap',
  },

  input: (theme: Theme) => ({
    fontWeight: 600,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,

    '& .user-admin-detail-input-error': {
      color: theme.colors.error[500],
    },
  }),

  dropdown: (theme: Theme) => ({
    ...muiSelectStyles.filterSelect(theme),
    width: '100%',
  }),

  fieldError: (theme: Theme) => ({
    color: theme.colors.error[500],
    flex: 1,
  }),

  placeholder: (theme: Theme) => ({
    color: theme.colors.neutral[500],
  }),
};
